// ข้อความตอนกดฟีเจอร์ที่ล็อกไว้ (ป้าย "อัปเกรด") — ไม่ระบุชื่อแพ็กโดยตั้งใจ ราคา/สิทธิ์
// ของแต่ละแพ็กแก้ได้ที่ฐานข้อมูลโดยไม่ deploy FE ชื่อแพ็กที่ฝังไว้ตรงนี้จะเพี้ยนเงียบๆ
//
// หน้า /billing เปิดได้เฉพาะ MANAGER / HEADCOUNTER (router meta.accessRoles) — role อื่น
// ถ้าให้ลิงก์ไปจะชน route guard จึงบอกให้ติดต่อผู้จัดการสาขาแทน
//
// แยกเป็นส่วน (featureName / reason / hint) ให้ popup จัดหน้าได้ — body คือข้อความรวม
export const buildUpgradeNotice = ({ featureName, canOpenBilling }) => {
  const reason = "ไม่รวมอยู่ในแพ็กปัจจุบันของสาขา";
  const hint = canOpenBilling
    ? "อัปเกรดแพ็กเพื่อใช้งานได้ทันที"
    : "กรุณาติดต่อผู้จัดการสาขาเพื่ออัปเกรดแพ็ก";
  return {
    title: "ต้องอัปเกรดแพ็ก",
    featureName,
    reason,
    hint,
    body: `${featureName} ${reason} ${hint}`,
    showBillingLink: Boolean(canOpenBilling),
  };
};
